import React from 'react';
import styles from './NotConnected.css';

class NotConnected extends React.Component {
  render() {
    return <div className={styles['text-grey']}>Not Connected</div>;
  }
}

export default NotConnected;
